import AddEvaluationManagerFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationManagerFormLanding';
import AddEvaluationSelfFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationSelfFormLanding';
import ToolTip from '../../ToolTip/ToolTip';

const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};

const evaluationStatusesJson = [
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Self Appraisal Completed' },
  { id: 2, name: 'Manager Appraisal Completed' },
];

export const selfAppraisalTableHeader = (api, SelfAppraisalDispatchParams) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
  },
  {
    field: 'appraisal_cycle_name',
    headerName: 'Cycle Name',
    width: 250,
  },
  {
    field: 'selfAppraisalStartDate',
    headerName: 'Self Appraisal Start Date',
    width: 200,
  },
  {
    field: 'selfAppraisalEndDate',
    headerName: 'Self Appraisal End Date',
    width: 200,
  },

  {
    field: 'evaluation_status',
    headerName: 'Status',
    width: 250,
    valueGetter: (params) => {
      return evaluationStatusesJson.find((sts) => sts.id == params.row?.evaluation_status)?.name || 'Other';
    },
  },
    {
    field: 'isSelfAppraisalActive ',
    headerName: 'Appraisal Deadline Status',
    width: 200,
    valueGetter: (params) => {
      return params.row?.isSelfAppraisalActive ? 'Active' : 'Date Expired';
    },
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 250,
    renderCell: (params) => {
      const viewOnly = params.row?.evaluation_status != 0;
      return(
      <AddEvaluationSelfFormLanding
        id={params.row?.appraisal_cycle_id}
        title={params.row?.appraisal_cycle_name}
        afterFormSubmissionApi={api}
        AfterFormdispatchParams={SelfAppraisalDispatchParams}
        extraDisable={viewOnly?false:!params.row?.isSelfAppraisalActive} //DISABLE THE BUTTON IF THE SELF APPRAISAL COMPLETED
        viewOnly={viewOnly} //IF THE SELF APPRASIAL COMPLETED IT IS CONVERTED TO VIEW MODE
      />
    );
    }
  },
];
